import React from 'react'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import { EMOJIS } from 'app/constants/feed'
import Button from 'app/components/ButtonDefault'

import './styles.scss'
const bc = 'story-list-item'

const StoryListItem = ({ t, activityUserStory, isMobileOnly, handleEdit, handleDelete }) => {
  const { story, activity, reactions, createdAt } = activityUserStory
  const { proTrackLevel, image, name, question } = activity
  const sortedReactions = reactions.reduce((res, next) => {
    const { emoji } = next
    if (!res[emoji]) {
      res[emoji] = 1
    } else {
      res[emoji]++
    }
    return res
  }, {})
  return (
    <div className={bc}>
      <div className={`${bc}__image`} style={{ backgroundImage: `url(${image})` }} />
      <div className={`${bc}__info`}>
        {isMobileOnly && <div className={`${bc}__name ${bc}__name--single`}>{name}</div>}
        <div className={`${bc}__header`}>
          {!isMobileOnly && <div className={`${bc}__name ${bc}__divider`}>{name}</div>}
          <div className={`${bc}__divider`}>{`${proTrackLevel.proTrack.name} (Level ${proTrackLevel.order})`}</div>
          <div>{moment(createdAt).fromNow()}</div>
        </div>
        <div className={`${bc}__question`}>{question}</div>
        <div className={`${bc}__story`} dangerouslySetInnerHTML={{ __html: story }} />
        {reactions.length > 0 && (
          <div className={`${bc}__reactions`}>
            {Object.keys(sortedReactions).map(key => {
              const emoji = EMOJIS.find(item => item.name === key)
              if (!emoji) {
                return null
              }
              return (
                <div className={`${bc}__emoji`} key={key}>
                  {React.createElement(emoji.icon)}
                  <span className={`${bc}__counter`}>{sortedReactions[key]}</span>
                </div>
              )
            })}
          </div>
        )}
        <div className={`${bc}__buttons`}>
          <Button primary sm onClick={handleEdit}>
            {t('Edit')}
          </Button>
          <Button remove sm onClick={handleDelete}>
            {t('Delete')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(StoryListItem)
